<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="mType == '1'">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/purchase' }">供应商合同管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}供应商合同</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item>{{mType == '2' ? '行政采购项目' : '人力资源项目'}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: mType == '2' ? '/adPurchase' : '/hrPurchase' }">供应商合同管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}供应商合同</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">供应商信息</div>
        <el-form-item label="选择供应商：" prop="vendor">
          <el-col :span="12">
            <el-select v-model="form.vendor" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="vendorChange" filterable>
              <el-option :label="v.vendor" :value="v.id" v-for="(v, i) in vendorList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- 自动载入部分 公司 -->
        <template v-if="form.vendor_type == 1">
          <el-form-item label="供应商类型：" prop="vendor_type">
            <el-col :span="12">
              <el-select v-model="form.vendor_type" placeholder="供应商类型" style="margin-right: 0; width: 100%;" disabled>
                <el-option label="公司" value="1"></el-option>
                <el-option label="个人" value="2"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="联系人姓名：" prop="name">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.name" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="联系人电话：" prop="phone">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.phone" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="联系人邮箱：" prop="email">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.email" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="收款账户：" prop="payee_name">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.payee_name" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="银行名称：" prop="payee_bank">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.payee_bank" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="银行账号：" prop="payee_bank_account">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.payee_bank_account" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="统一社会信用代码：" :rules="form.vendor_type === 1 ? company_id_card_rules : emptyRules">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.company_id_card" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="公司注册地址：" prop="reg_address">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.reg_address" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="公司电话：" prop="company_phone">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.company_phone" clearable />
            </el-col>
          </el-form-item>
        </template>
        <!-- 自动载入部分 个人 -->
        <template v-if="form.vendor_type == 2">
          <el-form-item label="供应商类型：" prop="vendor_type">
            <el-col :span="12">
              <el-select v-model="form.vendor_type" placeholder="供应商类型" style="margin-right: 0; width: 100%;" disabled>
                <el-option label="公司" value="1"></el-option>
                <el-option label="个人" value="2"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="身份证号：" prop="id_card" :rules="form.vendor_type === 2 ? id_card_rules : emptyRules">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.id_card" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="联系人电话：" prop="phone">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.phone" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="联系人邮箱：" prop="email">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.email" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="收款账户：" prop="payee_name">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.payee_name" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="银行名称：" prop="payee_bank">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.payee_bank" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="银行账号：" prop="payee_bank_account">
            <el-col :span="12">
              <el-input placeholder="请输入" maxlength="100" v-model="form.payee_bank_account" clearable />
            </el-col>
          </el-form-item>
        </template>

        <div class="formtitle">供应商合同信息</div>
        <template v-if="level == 1">
          <el-form-item label="合同编号：" prop="contract_no">
            <el-col :span="12">
              <el-input placeholder="请正确填写合同编号" maxlength="100" v-model="form.contract_no" clearable />
            </el-col>
          </el-form-item>
        </template>
        <el-form-item label="选择合同类型：" prop="contract_type">
          <el-col :span="12">
            <el-select v-model="form.contract_type" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="contractChange">
              <el-option label="单一合同" value="1" :disabled="query.kind != 1"></el-option>
              <el-option label="框架合同" value="2" :disabled="query.kind == 1"></el-option>
              <el-option label="补充合同" value="3" :disabled="query.kind != 1"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- 所属合同 -->
        <el-form-item label="所属合同：" prop="parent_contract_id" v-if="form.contract_type == 3">
          <el-col :span="12">
            <el-select v-model="form.parent_contract_id" placeholder="请选择" style="margin-right: 0; width: 100%;" clearable
              filterable>
              <el-option :label="v.contract_no + '-' + v.contract_name" :value="v.id" v-for="(v, i) in contractList"
                :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="供应商合同名称：" prop="contract_name">
          <el-col :span="12">
            <el-input placeholder="请输入" maxlength="100" v-model="form.contract_name" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="供应商合同时间：" prop="contract_time">
          <el-col :span="12">
            <el-date-picker v-model="form.contract_time" type="datetimerange" range-separator="--"
              value-format="yyyy-MM-dd" start-placeholder="合同开始时间" end-placeholder="合同结束时间" style="width:100%;"
              @change="contractTime">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <template v-if="form.contract_type != 2">
          <el-form-item label="供应商合同金额：" prop="contract_amount">
            <el-col :span="12">
              <el-input placeholder="请正确填写合同含税金额" maxlength="100" v-model="form.contract_amount" clearable
                @change="taxChange" />
            </el-col>
          </el-form-item>
          <el-form-item label="税率：" prop="tax_rate">
            <el-col :span="12">
              <el-select v-model="form.tax_rate" placeholder="请选择" style="margin-right: 0; width: 100%;"
                @change="taxChange">
                <el-option label="0%" value="0"></el-option>
                <el-option label="1%" value="1"></el-option>
                <el-option label="3%" value="3"></el-option>
                <el-option label="6%" value="6"></el-option>
                <el-option label="9%" value="9"></el-option>
                <el-option label="13%" value="13"></el-option>
                <el-option label="20%" value="20"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="税额：" prop="tax">
            <el-col :span="12">
              {{ form.tax }}
            </el-col>
          </el-form-item>
        </template>

        <template v-if="NodeInclude('254')">
          <ul class="anlist">
            <li v-for="(item, index) in fileList" :key="index">
              <div class="abox">
                <el-form-item :label='`电子合同附件${index + 1}：`'>
                  <!-- 选择文件 -->
                  <el-col :span="3">
                    <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                      :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                      :on-change="(arg) => uploadFile(arg, 'fileList', 'upFile', item, index)">
                      <el-button size="small" style="width: 80px;">选择文件</el-button>
                    </el-upload>
                  </el-col>
                  <!-- 文件预览及下载 -->
                  <template v-if="item.origin_name">
                    <el-col :span="10">
                      <el-col :span="18">
                        <div class="origin-name">{{ item.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                          target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                  </template>
                </el-form-item>
              </div>
              <el-button class="bbtn" icon="el-icon-minus" @click="removeImage(fileList, index)"
                circle></el-button>
            </li>
            <el-button type="primary" style="margin: 0 0 15px 150px;" class="addbtn" @click="addImage(fileList)">新增电子合同</el-button>
          </ul>
        </template>

        <template v-if="NodeInclude('93')">
          <ul class="anlist">
            <li v-for="(item, index) in fileList1" :key="index">
              <div class="abox">
                <el-form-item :label='`盖章合同附件${index + 1}：`'>
                  <!-- 选择文件 -->
                  <el-col :span="3" v-if="form.contract_no && form.contract_no != 'TBD'">
                    <el-upload class="upload-demo" ref="upFile1" action="#" :limit="1" :show-file-list="false"
                      :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                      :on-change="(arg) => uploadFile(arg, 'fileList1', 'upFile1', item, index)">
                      <el-button size="small" style="width: 80px;">选择文件</el-button>
                    </el-upload>
                  </el-col>
                  <el-col :span="3" v-else>
                    <el-button size="small" style="width: 80px;" @click="showWrongFn">选择文件</el-button>
                  </el-col>
                  <!-- 文件预览及下载 -->
                  <template v-if="item.origin_name">
                    <el-col :span="10">
                      <el-col :span="18">
                        <div class="origin-name">{{ item.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                          target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                  </template>
                </el-form-item>
              </div>
              <el-button class="bbtn" icon="el-icon-minus" @click="removeImage1(fileList1, index)"
                circle></el-button>
            </li>
            <el-button type="primary" style="margin: 0 0 15px 150px;" class="addbtn" @click="addImage1(fileList1)">新增盖章合同</el-button>
          </ul>
        </template>

        <el-form-item label="备注：" prop="info">
          <el-col :span="12">
            <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
              v-model="form.info">
            </el-input>
          </el-col>
        </el-form-item>

        <template v-if="form.contract_type != '2' && (form.client_id && form.client_id != '0')">
          <div class="formtitle">客户合同信息</div>
          <el-form-item label="选择客户名称：" prop="client_id">
            <el-col :span="12">
              <el-select v-model="form.client_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
                @change="companyChange" filterable :disabled="query.kind == 1">
                <el-option :label="v.company" :value="v.id" v-for="(v, i) in clientList" :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="选择品牌：" prop="brand">
            <el-col :span="12">
              <el-select v-model="form.brand" placeholder="请选择" style="margin-right: 0; width: 100%;"
                @change="brandChange" clearable filterable :disabled="query.kind == 1">
                <el-option :label="item.brand" :value="item.brand" v-for="(item, index) in brandArr.brandList"
                  :key="index"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="选择项目名称：" prop="project_id">
            <el-col :span="12">
              <el-select v-model="form.project_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
                @change="projectChange" clearable filterable :disabled="query.kind == 1">
                <el-option :label="item.contract_no + '-' + item.contract_name" :value="item.id"
                  v-for="(item, index) in projectList" :key="index"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="项目负责人：" prop="manager_name">
            <el-col :span="12">
              {{ form.manager_name }} {{ form.manager_enname }}
            </el-col>
          </el-form-item>
        </template>

        <el-form-item label="">
          <el-col :span="12">
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
import { timeFormat, antiThousands } from '@/utils/index.js'
export default {
  name: 'prodetail',
  data() {
    return {
      nodeLimtList: [],
      mType: '1',
      conShow: false,
      level: '',
      clientList: [],
      brandArr: {
        brandList: []
      },
      vendorList: [],
      projectList: [],
      contractList: [],
      form: {
        client_id: '',
        client_company: '',
        brand: '',
        project_id: '',
        manager_name: '',
        manager_enname: '',
        budget: 0, //如果没有payid，设定预算为0
        //供应商信息
        contract_id: '',
        vendor_id: '',
        vendor: '',
        vendor_type: '1',
        name: '',
        phone: '',
        email: '',
        payee_name: '',
        payee_bank: '',
        payee_bank_account: '',
        company_id_card: '',
        reg_address: '',
        company_phone: '',
        id_card: '',
        family_address: '',
        //合同信息
        contract_no: '',
        contract_type: '2',
        parent_contract_id: '',
        contract_name: '',
        contract_time: ['', ''],
        contract_start_time: '',
        contract_end_time: '',
        contract_amount: '',
        tax_rate: '6',
        tax: '',
        info: '',
        atta_str: '',//合同附件数组(json串) file_type 1电子合同 2盖章合同
        atta_del: '',
      },
      rules: {
        vendor: [
          {
            required: true,
            message: '请选择供应商',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入联系人姓名',
            trigger: 'change',
          },
        ],
        phone: [
          {
            required: true,
            message: '请输入联系人电话',
            trigger: 'change',
          },
        ],
        payee_name: [
          {
            required: true,
            message: '请输入收款账户',
            trigger: 'change',
          },
        ],
        payee_bank: [
          {
            required: true,
            message: '请输入银行名称',
            trigger: 'change',
          },
        ],
        payee_bank_account: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'change',
          },
        ],
        contract_type: [
          {
            required: true,
            message: '请选择合同类型',
            trigger: 'change',
          },
        ],
        contract_name: [
          {
            required: true,
            message: '请填写项目名称',
            trigger: 'change',
          },
        ],
      },
      company_id_card_rules: [
        {
          required: true,
          message: '请输入统一社会信用代码',
          trigger: 'change',
        },
      ],
      id_card_rules: [
        {
          required: true,
          message: '请输入身份证号码',
          trigger: 'change',
        },
      ],
      emptyRules: [],
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      fileList1: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
      del_atta_list1: [],
    }
  },
  created() {
    this.query = this.$route.query
    this.mType = this.query.mType
    this.query.id && this.getDetail(this.query.id)//取合同详情
    this.query.kind == '1' && (this.form.contract_type = '1') //项目选择单一或补充
    this.query.pid && this.getProjectDetail(this.query.pid) //取项目详情
    this.query.vid && this.vendorChange(this.query.vid) //供应商详情
    this.query.payid && this.getPayDetail(this.query.payid) //取支出详情
  },
  mounted() {
    this.getClientList()
    this.getVendorList()
  },
  watch: {
    ['form.payee_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.payee_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
    ['form.phone'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.phone = val.replace(/\D/g, '');
        });
      }
    },
    ['form.company_phone'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.company_phone = val.replace(/\D/g, '');
        });
      }
    },
    // ['form.id_card'](val) {
    //   if (val != undefined) {
    //     this.$nextTick(() => {
    //       this.form.id_card = val.replace(/\D/g, '');
    //     });
    //   }
    // },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 2);
      api.uploadFile(formData)
        .then((res) => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addImage(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
    },
    addImage1(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage1(arr, index) {
      if (arr[index].id) {
        this.del_atta_list1.push(arr[index].id);
      }
      console.log(this.del_atta_list1);
      arr = arr.splice(index, 1);
    },
    async getClientList() {
      this.$fly
        .post('apiSale_getClientList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.clientList = res.itemList
        })
    },
    async getVendorList() {
      // console.log(postData)
      this.$fly
        .post('apiPurchase_getVendorList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.vendorList = res.itemList
        })
    },
    companyChange(v) {//公司变化，清空品牌
      return new Promise((resolve, reject) => {
        this.$fly
          .post('apiSale_getClientDetail.html', { client_id: v })
          .then((res) => {
            if (res) {
              this.brandArr = res.itemArr
              this.form = {
                ...this.form,
                client_id: v,
                client_company: this.form.projectArr.client_company,
                brand: '',//清空客户表
                project_id: '',
                manager_name: '',
                manager_enname: '',
              }
              resolve(res)
            }
            else {
              reject('error')
            }
          })
      })
    },
    brandChange(v) {
      return new Promise((resolve, reject) => {
        this.form.brand = v
        this.$fly
          .post('apiProject_getList.html', {
            client_company: this.form.projectArr.client_company,
            brand: v,
            per_page: 5000,
            search_source: 1,
          })
          .then((res) => {
            if (res) {
              this.projectList = res.itemList
              resolve(res)
            }
            else {
              reject('error')
            }
          })
      })
    },
    projectChange(v) {
      this.form.project_id = v
      this.projectList = this.projectList.map(item => {
        if (item.id == v) {
          this.form.manager_name = item.manager_name
          this.form.manager_enname = item.manager_enname
        }
        return item
      })
    },
    vendorChange(v) {//公司变化，填写供应商信息
      if (v) {
        this.form.vendor_id = v
        if (this.query.kind == '1') {
          this.form.contract_type = '1'
          this.form.parent_contract_id = ''          
        }
        this.$fly
          .post('apiPurchase_getVendorDetail.html', { vendor_id: v })
          .then((res) => {
            const {
              vendor,
              type,
              name,
              phone,
              email,
              payee_name,
              payee_bank,
              payee_bank_account,
              company_id_card,
              reg_address,
              company_phone
            } = res.itemArr
            this.form = {
              ...this.form,
              vendor,
              vendor_type: type,
              name: name ? name : vendor,
              phone,
              email,
              payee_name,
              payee_bank,
              payee_bank_account,
              company_id_card,
              reg_address,
              company_phone
            }
            const { client_company, brand, vendor_id } = this.form
            this.$fly
              .post('apiPurchase_getContractList.html', {
                per_page: 5000,
                client_company,
                brand,
                vendor_id,
                mType: this.mType,
              })
              .then((res) => {
                this.contractList = res.itemList.filter(item => item.status == '2' || item.status == '3')
              })
          })
      }
    },
    contractChange(v) {//补充合同
      if (v == 3) {
        const { client_company, brand, vendor_id } = this.form
        this.$fly
          .post('apiPurchase_getContractList.html', {
            per_page: 5000,
            client_company,
            brand,
            vendor_id,
            mType: this.mType,
          })
          .then((res) => {
            this.contractList = res.itemList.filter(item => item.status == '2' || item.status == '3')
          })
      }
      else {
        this.form.parent_contract_id = ''
      }
    },
    taxChange() {//计算税额，同时合同金额变化，重新计算余值
      this.form.contract_amount = this.form.contract_amount.toString().replace(/,/g, "")
      const amount = Number(this.form.contract_amount);
      const taxRate = Number(this.form.tax_rate);
      this.form.tax = (amount / ((100 + taxRate) / 100) * taxRate / 100).toFixed(2)
    },
    //项目时间调整
    contractTime() {
      const time = this.form.contract_time
      this.form.contract_start_time = this.fdate(time[0])
      this.form.contract_end_time = this.fdate(time[1])
    },
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.$fly
        .post('apiPurchase_getContractDetail.html', {
          contract_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          //修改0000-00-00错误显示1899年情况
          form.contract_start_time = timeFormat(form.contract_start_time)
          form.contract_end_time = timeFormat(form.contract_end_time)
          //初始contract_time
          form.contract_time = ['', '']
          form.contract_time[0] = form.contract_start_time
          form.contract_time[1] = form.contract_end_time
          form.budget = form.payArr.budget
          this.mType = form.project_type
          this.fileList = res.itemArr.fileList.filter(item => item.file_type == '1').map((item) => {
            delete item.project_id
            delete item.create_time
            item.flist = []
            return item
          })
          this.fileList1 = res.itemArr.fileList.filter(item => item.file_type == '2').map((item) => {
            delete item.project_id
            delete item.create_time
            item.flist = []
            return item
          })
          //防空情况       
          if (this.fileList.length === 0) {
            this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          }
          if (this.fileList1.length === 0) {
            this.fileList1 = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          }
          this.getClientDetail(form)
          if (form.contract_type) {
            this.contractChange(3)
          }
          setTimeout(() => {
            //权限
            this.level = store.state.level
            this.realName = store.state.realName
          }, 200);
          this.form = form
        })
    },
    getPayDetail(id) {
      this.$fly
        .post('apiProject_getPayDetail.html', {
          pay_id: id,
        })
        .then((res) => {
          this.form.budget = res.itemArr.budget
          this.form.son_project_id = res.itemArr.son_project_id
        })
    },
    getProjectDetail(id) {
      this.$fly
        .post('apiProject_getDetail.html', {
          project_id: id,
        })
        .then((res) => {
          this.form.projectArr = res.itemArr
          this.getClientDetail(this.form)
        })
    },
    getClientDetail(form) {//客户合同区域内容
      if (Object.keys(form.projectArr).length) {
        const { client_id, client_company, brand, manager_name, manager_enname} = form.projectArr
        form = {
          ...form,
          client_id,
          client_company,
          brand,
          manager_name,
          manager_enname,
          project_id: this.query.pid || form.project_id,
          vendor_id: this.query.vid || form.vendor_id,
        }
      }
      if (form.client_id != '0') {//非客户合同
        this.companyChange(form.client_id).then(() => {
          this.brandChange(form.brand).then(() => {
            this.projectChange(form.project_id)
          })
        })
      }
      else {
        this.form.project_id = this.query.pid
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateProject()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateProject() {
      this.form.contract_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      if (!this.mType) {
        this.$message.error('请返回列表重新创建')
        return false
      }
      if (this.form.contract_no != '' && this.form.contract_no != 'TBD') {
        if (this.level != 1) {
          this.$message.error('已获取合同编号后不能编辑！')
          return false
        }
      }
      if (this.form.contract_type != '2') {
        if (this.form.budget) {
          const flag = (antiThousands(this.form.contract_amount) * 100 - antiThousands(this.form.budget) * 100) / 100
          if (flag > 0) {
            this.$message.error('供应商合同金额不能大于对应预算金额')
            return false
          }
        }
        else {
          this.$message.error('供应商合同无对应审核通过的预算')
          return false
        }
      }
      if (this.form.contract_type == '3' && (!this.form.parent_contract_id || this.form.parent_contract_id == '0')) {
        console.log(this.form.parent_contract_id);
        this.$message.error('补充合同需要对应所属合同')
        return false
      }
      //替换掉id为file_id
      let fileList = this.fileList.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 1
        return item
      })
      let fileList1 = this.fileList1.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 2
        return item
      })
      fileList = fileList.concat(fileList1)
      let del_atta_list = this.del_atta_list
      let del_atta_list1 = this.del_atta_list1
      const del_atta = del_atta_list.concat(del_atta_list1)
      const $fileList = fileList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key]
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      fileList = $fileList
      const tempForm = JSON.parse(JSON.stringify(this.form))
      console.log(this.form);
      delete tempForm.is_apply
      delete tempForm.status
      delete tempForm.projectArr
      delete tempForm.fileList
      this.$fly
        .post('apiPurchase_addUpdateContract.html', {
          contract_id: tempForm.id,
          ...tempForm,
          atta_str: JSON.stringify(fileList),
          atta_del: del_atta.toString(),
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          if (this.query.kind == 1) {
            this.$fly
              .post('apiProject_addUpdatePay.html', {
                pay_id: this.query.payid,
                project_id: this.query.pid,
                son_project_id: this.form.son_project_id,
                vendor_id: this.query.vid || this.form.vendor_id,
                contract_id: res.contractId,
                option: 2,
                mType: this.mType,
              })
              .then((res) => {
                if (res.status === 200) {
                  this.$message.success('支付计划已更新')
                  this.$router.go(-1)
                }
              })
          }
          else {
            this.$message.success('合同已更新')
            this.$router.go(-1)
          }
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    showWrongFn() {
      this.$message.error('请先获取合同编号')
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }
}
</style>
